var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24 ",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.538 2.36715L19.6316 1.45941C17.7609 -0.412724 14.8015 -0.495623 13.0261 1.2798L1.27827 13.0266C-0.495728 14.802 -0.412831 17.7587 1.46202 19.6336L2.3656 20.5372C4.24045 22.4121 7.19849 22.4964 8.97386 20.7224L20.7217 8.97143C22.4957 7.20016 22.4128 4.24205 20.538 2.36715ZM13.891 14.0186L8.02607 8.15073L13.8399 2.33676C15.1455 1.03248 17.3382 1.09604 18.7239 2.48459L19.5584 3.31496C20.2354 3.99612 20.6236 4.88313 20.6457 5.81437C20.6613 6.25569 20.5859 6.69549 20.4243 7.10645C20.2627 7.51741 20.0182 7.89074 19.7062 8.20324L13.891 14.0186Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOral);
export default __webpack_public_path__ + "static/media/oral.8748a32b.svg";
export { ForwardRef as ReactComponent };